import {Clock} from 'lucide-react';

const Timer = ({timeRemaining}) => {
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    const isUrgent = timeRemaining <= 60;

    return (
        <div
            className={`flex items-center gap-3 px-6 py-4 rounded-2xl transition-all ${
                isUrgent
                    ? 'bg-red-500 dark:bg-red-600 shadow-lg shadow-red-500/50 animate-pulse'
                    : 'bg-white/20 dark:bg-slate-800/70 backdrop-blur-sm'
            }`}
        >
            <Clock className={`w-6 h-6 ${isUrgent ? 'animate-bounce' : ''}`}/>
            <div className="text-left text-gray-900 dark:text-gray-100">
                <p className="text-xs opacity-90 mb-1">زمان باقی‌مانده</p>
                <p className="text-3xl font-bold font-mono">
                    {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
                </p>
            </div>
        </div>
    );
};

export default Timer;